export default "__VITE_ASSET__Mo44r1kx__"